export var EFamilyPersonRole;
(function (EFamilyPersonRole) {
    EFamilyPersonRole["MEMBER"] = "Member";
    EFamilyPersonRole["MANAGER"] = "Manager";
})(EFamilyPersonRole || (EFamilyPersonRole = {}));
